// extracted by mini-css-extract-plugin
export var button__primary = "styles-module--button__primary--8bdff";
export var col1 = "styles-module--col1--a2b65";
export var col2 = "styles-module--col2--12532";
export var col3 = "styles-module--col3--e069e";
export var cursor = "styles-module--cursor--e1459";
export var cursorFollower = "styles-module--cursor-follower--1b87f";
export var headingCentered = "styles-module--heading-centered--465d2";
export var legalItem = "styles-module--legal-item--791bc";
export var logo = "styles-module--logo--be6d4";
export var navList = "styles-module--nav-list--029d7";
export var navListItem = "styles-module--nav-list-item--35d24";
export var noScroll = "styles-module--no-scroll--0f7f9";
export var pageTemplatePageGame = "styles-module--page-template-page-game--66577";
export var section__wrapper = "styles-module--section__wrapper--b2c0c";
export var section__wrapperLarge = "styles-module--section__wrapper--large--b08f4";
export var socialItem = "styles-module--social-item--2cbec";
export var socialList = "styles-module--social-list--3490e";
export var wrapper = "styles-module--wrapper--88c66";